// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","errorMessageWrapper":"EditShippingAdress_errorMessageWrapper__wD49s"};